import classNames from 'classnames';
import {Link} from 'react-router';
import React, {useEffect} from 'react';

import {LoadingSpinner, Menu, Text} from '@albert-io/atomic';
import useBreakpoint from 'lib/hooks/useBreakpoint';
import ClassroomFlair from '../ClassroomFlair';
import useClassrooms from './hooks/useClassrooms';
import {useStudentHomepageStore} from '../useStudentHomepageStore';

interface Props {
  pathname: string;
}

export default function SidebarContent({pathname}: Props) {
  const {isSAndDown} = useBreakpoint();
  const currentTab = pathname.split('/').slice(-1)[0];

  const setIsSidebarExpanded = useStudentHomepageStore((state) => state.setIsSidebarExpanded);
  const setShowJoinClassModal = useStudentHomepageStore((state) => state.setShowJoinClassModal);

  const {areClassroomsLoading, classrooms, fetchClassrooms} = useClassrooms();

  useEffect(() => {
    fetchClassrooms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const menuItemClassNames = 'px-x2! py-x1-half! no-underline items-start! gap-x0!';

  function onSidebarLinkClick() {
    if (isSAndDown) {
      setIsSidebarExpanded(false);
    }
  }

  return (
    <div className='flex h-full flex-col gap-x3'>
      <div
        className={classNames('flex-1 wrap-anywhere', {
          'flex items-center justify-center': areClassroomsLoading,
          'max-h-19/20 overflow-y-auto': !areClassroomsLoading
        })}
      >
        {areClassroomsLoading ? (
          <LoadingSpinner bottomMarginLevel={0} size={3} />
        ) : (
          <>
            <Text className='mb-x1-half ml-x2 block' color='secondary' size='s'>
              Classrooms
            </Text>
            <Menu.Item
              as={Link}
              className={menuItemClassNames}
              onClick={onSidebarLinkClick}
              preventDefaultClickHandler={false}
              selected={!pathname.includes('class')}
              to={`/home/${currentTab}`}
            >
              <ClassroomFlair isForAll />
              All Classes
            </Menu.Item>
            {classrooms.size === 0 ? (
              <div className='my-x2 rounded-x1 border border-dashed border-primary px-x2 py-x3 text-center'>
                <Text color='secondary' size='xs'>
                  Your classes will appear here
                </Text>
              </div>
            ) : (
              <>
                {classrooms.map((classroom) => {
                  const to = `/home/class/${classroom.getId()}/${currentTab}`;

                  return (
                    <Menu.Item
                      className={menuItemClassNames}
                      as={Link}
                      key={classroom.getId()}
                      onClick={onSidebarLinkClick}
                      preventDefaultClickHandler={false}
                      to={to}
                      selected={pathname.includes(to)}
                    >
                      <ClassroomFlair isForAll={false} classroom={classroom} />
                      {classroom.getName()}
                    </Menu.Item>
                  );
                })}
                <Menu.Item
                  className='mt-x1-half content-brand!'
                  leftIconProps={{icon: 'plus'}}
                  onClick={() => {
                    setShowJoinClassModal(true);
                  }}
                >
                  Join Class
                </Menu.Item>
              </>
            )}
          </>
        )}
      </div>
      <Menu.Item
        as={Link}
        className={menuItemClassNames}
        leftIconProps={{icon: 'chart-line'}}
        preventDefaultClickHandler={false}
        to='/my-data'
      >
        My Data
      </Menu.Item>
    </div>
  );
}
